!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("flatpickr")) : "function" == typeof define && define.amd ? define("VueFlatpickr", ["flatpickr"], e) : "object" == typeof exports ? exports.VueFlatpickr = e(require("flatpickr")) : t.VueFlatpickr = e(t.flatpickr);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 1);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "Component", function () {
      return p;
    }), n.d(e, "Plugin", function () {
      return d;
    });
    var r = n(0),
      o = n.n(r),
      i = ["onChange", "onClose", "onDestroy", "onMonthChange", "onOpen", "onYearChange"];
    function u() {
      return (u = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    var a = function (t) {
        return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
      },
      f = function (t) {
        return t && t.length ? t : null;
      },
      l = function (t) {
        return u({}, t);
      },
      s = i.concat(["onValueUpdate", "onDayCreate", "onParseConfig", "onReady", "onPreCalendarPosition", "onKeyDown"]),
      c = ["locale", "showMonths"],
      p = {
        name: "flat-pickr",
        render: function (t) {
          return t("input", {
            attrs: {
              type: "text",
              "data-input": !0
            },
            props: {
              disabled: this.disabled
            },
            on: {
              input: this.onInput
            }
          });
        },
        props: {
          value: {
            default: null,
            required: !0,
            validator: function (t) {
              return null === t || t instanceof Date || "string" == typeof t || t instanceof String || t instanceof Array || "number" == typeof t;
            }
          },
          config: {
            type: Object,
            default: function () {
              return {
                wrap: !1,
                defaultDate: null
              };
            }
          },
          events: {
            type: Array,
            default: function () {
              return i;
            }
          },
          disabled: {
            type: Boolean,
            default: !1
          }
        },
        data: function () {
          return {
            fp: null
          };
        },
        mounted: function () {
          var t = this;
          if (!this.fp) {
            var e = l(this.config);
            this.events.forEach(function (n) {
              var r,
                i = o.a.defaultConfig[n] || [];
              e[n] = (r = e[n] || [], r instanceof Array ? r : [r]).concat(i, function () {
                for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++) r[o] = arguments[o];
                t.$emit.apply(t, [a(n)].concat(r));
              });
            }), e.defaultDate = this.value || e.defaultDate, this.fp = new o.a(this.getElem(), e), this.fpInput().addEventListener("blur", this.onBlur), this.$on("on-close", this.onClose), this.$watch("disabled", this.watchDisabled, {
              immediate: !0
            });
          }
        },
        methods: {
          getElem: function () {
            return this.config.wrap ? this.$el.parentNode : this.$el;
          },
          onInput: function (t) {
            var e = this,
              n = t.target;
            this.$nextTick(function () {
              e.$emit("input", f(n.value));
            });
          },
          fpInput: function () {
            return this.fp.altInput || this.fp.input;
          },
          onBlur: function (t) {
            this.$emit("blur", f(t.target.value));
          },
          onClose: function (t, e) {
            this.$emit("input", f(e));
          },
          watchDisabled: function (t) {
            t ? this.fpInput().setAttribute("disabled", t) : this.fpInput().removeAttribute("disabled");
          }
        },
        watch: {
          config: {
            deep: !0,
            handler: function (t) {
              var e = this,
                n = l(t);
              s.forEach(function (t) {
                delete n[t];
              }), this.fp.set(n), c.forEach(function (t) {
                void 0 !== n[t] && e.fp.set(t, n[t]);
              });
            }
          },
          value: function (t) {
            t !== f(this.$el.value) && this.fp && this.fp.setDate(t, !0);
          }
        },
        beforeDestroy: function () {
          this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
        }
      },
      d = function (t, e) {
        var n = "flat-pickr";
        "string" == typeof e && (n = e), t.component(n, p);
      };
    p.install = d;
    e.default = p;
  }]).default;
});